import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Link as RouterLink } from "react-router-dom";

const COOKIE_KEY = "ryze_cookie_consent";

const useStyles = makeStyles((theme) => ({
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    background: theme.palette.type === "dark" ? "#1e1e1e" : "#fff",
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    boxShadow: "0 -2px 12px rgba(0,0,0,0.12)",
  },
  text: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    flex: 1,
    minWidth: 200,
    "& a": {
      color: theme.palette.primary.main,
      textDecoration: "none",
      "&:hover": { textDecoration: "underline" },
    },
  },
  buttons: {
    display: "flex",
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  acceptBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
  },
  declineBtn: {
    textTransform: "none",
    fontSize: 13,
  },
}));

const CookieBanner = () => {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box className={classes.banner} role="region" aria-label="Cookie consent">
      <Typography className={classes.text}>
        We use cookies to personalize ads and analyze traffic. By clicking "Accept", you consent to our use of cookies.{" "}
        <RouterLink to="/privacy-policy">Read our privacy policy</RouterLink>
      </Typography>
      <Box className={classes.buttons}>
        <Button
          variant="outlined"
          size="small"
          className={classes.declineBtn}
          onClick={handleDecline}
        >
          Decline
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.acceptBtn}
          onClick={handleAccept}
        >
          Accept
        </Button>
      </Box>
    </Box>
  );
};

export default CookieBanner;
